<template>
  <v-navigation-drawer
    app
    temporary
    v-model="drawer"
    class="drawer"
  >
    <router-link to="/">
      <v-img class="drawer-img" src="/static/img/logo.png"></v-img>
      <div class="header">«МАЛИНА»</div>
      <div class="subheader">гостиница - сауна - хаммам</div>
    </router-link>

    <v-divider></v-divider>

    <v-list two-line dense class="pt-0">
      <v-list-tile
        v-for="link in links"
        :key="link.title"
        :to="link.url"
      >
        <v-list-tile-action>
          <v-icon medium>{{ link.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title class="title" v-text="link.title"></v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
    </v-list>
  </v-navigation-drawer>


  <!--
  <v-navigation-drawer
    app
    temporary
    v-model="drawer"
    class="drawer"
  >
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title>
            <h3>{{ project.name }}</h3>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>

    <v-list dense class="pt-0">
      <v-list-tile
        v-for="link in links"
        :key="link.title"
        :to="link.url"
      >
        <v-list-tile-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title class="subheading" v-text="link.title"></v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  -->
</template>

<script>
export default {
  computed: {
    drawer: {
      get () {
        return this.$store.state.drawer
      },
      set (drawer) {
        this.$store.state.drawer = drawer // записываем новое значение drawer в store
      }
    },
    project () {
      return this.$store.state.project
    },
    links () {
      return this.$store.state.links
    }
  }
}
</script>

<style scoped>
a,
a:hover,
a:visited,
a:active {
  color: black;
  text-decoration: none;
}

.drawer {
  z-index: 200;
}

.drawer-img {
    width: 35%;
    height: auto;
    margin: 20px auto;
}

.header {
  font-size: 19px;
  margin-left: 20px;
}

.subheader {
  margin-left: 20px;
  margin-bottom: 10px;
}

.drawer h3 {
  position: relative;
  top: -2px;
  left: 10px;
}

.drawer-row {
  height: 50px;
}

.drawer-items {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Drawer.vue